var cov_1s8alsl3ca = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Checkbox/Group.tsx",
      hash = "c410b2661a61e89022cfdf2c3dec0817479f2af6",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Checkbox/Group.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 28
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "1": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 16
        }
      },
      "2": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 50
        }
      },
      "3": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 52
        }
      },
      "4": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 58
        }
      },
      "5": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 29
        }
      },
      "6": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 63
        }
      },
      "7": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 32
        }
      },
      "8": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 65
        }
      },
      "9": {
        start: {
          line: 35,
          column: 27
        },
        end: {
          line: 35,
          column: 37
        }
      },
      "10": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "11": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 52
        }
      },
      "12": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 41,
          column: 5
        }
      },
      "13": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 26
        }
      },
      "14": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 13
        }
      },
      "15": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 22
        }
      },
      "16": {
        start: {
          line: 51,
          column: 28
        },
        end: {
          line: 51,
          column: 38
        }
      },
      "17": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 56,
          column: 5
        }
      },
      "18": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 29
        }
      },
      "19": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 32
        }
      },
      "20": {
        start: {
          line: 60,
          column: 22
        },
        end: {
          line: 60,
          column: 32
        }
      },
      "21": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 65,
          column: 5
        }
      },
      "22": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 22
        }
      },
      "23": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 25
        }
      },
      "24": {
        start: {
          line: 69,
          column: 60
        },
        end: {
          line: 69,
          column: 70
        }
      },
      "25": {
        start: {
          line: 70,
          column: 22
        },
        end: {
          line: 70,
          column: 118
        }
      },
      "26": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "27": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 79,
          column: 7
        }
      },
      "28": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 98,
          column: 5
        }
      },
      "29": {
        start: {
          line: 85,
          column: 10
        },
        end: {
          line: 94,
          column: 21
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 16
          },
          end: {
            line: 13,
            column: 17
          }
        },
        loc: {
          start: {
            line: 13,
            column: 28
          },
          end: {
            line: 13,
            column: 29
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 62
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 24
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 29,
            column: 25
          },
          end: {
            line: 32,
            column: 3
          }
        },
        line: 29
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        },
        loc: {
          start: {
            line: 34,
            column: 37
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 34
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        },
        loc: {
          start: {
            line: 46,
            column: 17
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 46
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 69
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 50
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 60
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 59
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 11
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 68
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 84,
            column: 18
          },
          end: {
            line: 84,
            column: 19
          }
        },
        loc: {
          start: {
            line: 85,
            column: 10
          },
          end: {
            line: 94,
            column: 21
          }
        },
        line: 85
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }],
        line: 36
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        }],
        line: 39
      },
      "2": {
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }],
        line: 52
      },
      "3": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 65,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 65,
            column: 5
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 65,
            column: 5
          }
        }],
        line: 61
      },
      "4": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }, {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }],
        line: 72
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Checkbox/Group.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { getKey } from '../utils/uid';
import { CHANGE_TOPIC } from '../Datum/types';
import Checkbox from './Checkbox';
import { Provider } from './context';
import { checkinputClass } from './styles';

var CheckboxGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CheckboxGroup, _PureComponent);

  var _super = _createSuper2(CheckboxGroup);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    cov_1s8alsl3ca.f[1]++;
    cov_1s8alsl3ca.s[1]++;
    _this = _super.call(this, props);
    cov_1s8alsl3ca.s[2]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_1s8alsl3ca.s[3]++;
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    cov_1s8alsl3ca.s[4]++;
    _this.handleRawChange = _this.handleRawChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1s8alsl3ca.f[2]++;
      cov_1s8alsl3ca.s[5]++;

      _get(_getPrototypeOf(CheckboxGroup.prototype), "componentDidMount", this).call(this);

      cov_1s8alsl3ca.s[6]++;
      this.props.datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1s8alsl3ca.f[3]++;
      cov_1s8alsl3ca.s[7]++;

      _get(_getPrototypeOf(CheckboxGroup.prototype), "componentWillUnmount", this).call(this);

      cov_1s8alsl3ca.s[8]++;
      this.props.datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "getContent",
    value: function getContent(d) {
      cov_1s8alsl3ca.f[4]++;

      var _ref = (cov_1s8alsl3ca.s[9]++, this.props),
          renderItem = _ref.renderItem;

      cov_1s8alsl3ca.s[10]++;

      if (typeof renderItem === 'string') {
        cov_1s8alsl3ca.b[0][0]++;
        cov_1s8alsl3ca.s[11]++;
        return d[renderItem];
      } else {
        cov_1s8alsl3ca.b[0][1]++;
      }

      cov_1s8alsl3ca.s[12]++;

      if (typeof renderItem === 'function') {
        cov_1s8alsl3ca.b[1][0]++;
        cov_1s8alsl3ca.s[13]++;
        return renderItem(d);
      } else {
        cov_1s8alsl3ca.b[1][1]++;
      }

      cov_1s8alsl3ca.s[14]++;
      return '';
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      cov_1s8alsl3ca.f[5]++;
      cov_1s8alsl3ca.s[15]++;
      this.forceUpdate();
    }
  }, {
    key: "handleClick",
    value: function handleClick(_val, checked, index) {
      cov_1s8alsl3ca.f[6]++;

      var _ref2 = (cov_1s8alsl3ca.s[16]++, this.props),
          data = _ref2.data,
          datum = _ref2.datum;

      cov_1s8alsl3ca.s[17]++;

      if (checked) {
        cov_1s8alsl3ca.b[2][0]++;
        cov_1s8alsl3ca.s[18]++;
        datum.add(data[index]);
      } else {
        cov_1s8alsl3ca.b[2][1]++;
        cov_1s8alsl3ca.s[19]++;
        datum.remove(data[index]);
      }
    }
  }, {
    key: "handleRawChange",
    value: function handleRawChange(value, checked) {
      cov_1s8alsl3ca.f[7]++;

      var _ref3 = (cov_1s8alsl3ca.s[20]++, this.props),
          datum = _ref3.datum;

      cov_1s8alsl3ca.s[21]++;

      if (checked) {
        cov_1s8alsl3ca.b[3][0]++;
        cov_1s8alsl3ca.s[22]++;
        datum.add(value);
      } else {
        cov_1s8alsl3ca.b[3][1]++;
        cov_1s8alsl3ca.s[23]++;
        datum.remove(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      cov_1s8alsl3ca.f[8]++;

      var _ref4 = (cov_1s8alsl3ca.s[24]++, this.props),
          block = _ref4.block,
          data = _ref4.data,
          datum = _ref4.datum,
          keygen = _ref4.keygen,
          children = _ref4.children,
          style = _ref4.style;

      var className = (cov_1s8alsl3ca.s[25]++, classnames(checkinputClass('group', ['no-block', 'block'][Number(block)]), this.props.className));
      cov_1s8alsl3ca.s[26]++;

      if (data === undefined) {
        cov_1s8alsl3ca.b[4][0]++;
        cov_1s8alsl3ca.s[27]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: className,
            style: style,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 74,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement(Provider, {
            value: {
              onRawChange: this.handleRawChange,
              checked: datum.check.bind(datum)
            },
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 75,
              columnNumber: 11
            }
          }, children))
        );
      } else {
        cov_1s8alsl3ca.b[4][1]++;
      }

      cov_1s8alsl3ca.s[28]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 83,
            columnNumber: 7
          }
        }, data.map(function (d, i) {
          cov_1s8alsl3ca.f[9]++;
          cov_1s8alsl3ca.s[29]++;
          return (
            /*#__PURE__*/
            React.createElement(Checkbox, {
              checked: datum.check(d),
              disabled: datum.disabled(d),
              key: getKey(d, keygen, i),
              htmlValue: i,
              index: i,
              onChange: _this2.handleClick,
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 85,
                columnNumber: 11
              }
            }, _this2.getContent(d))
          );
        }), children)
      );
    }
  }]);

  return CheckboxGroup;
}(PureComponent);

CheckboxGroup.defaultProps = {
  renderItem: function renderItem(d) {
    cov_1s8alsl3ca.f[0]++;
    cov_1s8alsl3ca.s[0]++;
    return d;
  }
};
export default CheckboxGroup;